import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppInfoComponent } from './common/app-info/app-info.component';
import { DashboardComponent } from './common/dashboard/dashboard.component';
import { LoginComponent } from './common/login/login.component';

import { AccessLogListComponent } from './access-log-list/access-log-list.component';
import { AppUserListComponent } from './app-user-list/app-user-list.component';
import { AppointmentListComponent } from './appointment-list/appointment-list.component';
import { AttendanceListComponent } from './attendance-list/attendance-list.component';
import { EmployeeMangementListComponent } from './employee-mangement-list/employee-mangement-list.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { GateListComponent } from './gate-list/gate-list.component';
import { ShiftBasedComponent } from './shift-based/shift-based.component';
import { MessageListComponent } from './message-list/message-list.component';

import { MenuComponent } from './menu/menu.component';
import { UnitListComponent } from './unit-list/unit-list.component';

import { VisitorMangementListComponent } from './visitor-mangement-list/visitor-mangement-list.component';
import { DepartmentComponent } from './department/department.component';
import { SignupComponent } from './common/signup/signup.component';
import { WorkingHoursComponent } from './working-hours/working-hours.component';
import { MobileLocationComponent } from './mobile-location/mobile-location.component';
import { MobileContactComponent } from './mobile-contact/mobile-contact.component';
import { CallLogsComponent } from './call-logs/call-logs.component';

import { MobileGalleryComponent } from './mobile-gallery/mobile-gallery.component';
import { MyProfileComponent } from './common/my-profile/my-profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EmployeeQrcodeListComponent } from './employee-qrcode-list/employee-qrcode-list.component';
import { EventLogListComponent } from './event-log-list/event-log-list.component';
import { EventListComponent} from './event-list/event-list.component'


const routes: Routes = [

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'login/:param',
    component: LoginComponent
  },
  {
    path: 'info',
    component: AppInfoComponent
  },
  {
    path: 'logout',
    component: LoginComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path: 'sessionOut',
    component: LoginComponent
  },
  {
    path: 'fb',
    component: ForgetPasswordComponent
  },
  {
    path: 'userList',
    component: AppUserListComponent
  },
  {
    path: 'appointmentList',
    component: AppointmentListComponent
  },
  {
    path: 'gateList',
    component: GateListComponent
  },
  {
    path: 'eventList',
    component: EventListComponent
  },
  {
    path: 'unitList',
    component: UnitListComponent
  },
  {
    path: 'visitorManagementList/:id',
    component: VisitorMangementListComponent
  },
  {
    path: 'visitorManagementList',
    component: VisitorMangementListComponent
  },
  {
    path: 'employeeManagementList/:id',
    component: EmployeeMangementListComponent
  },
  {
    path: 'employeeManagementList',
    component: EmployeeMangementListComponent
  },
  {
    path: 'shiftList',
    component: ShiftBasedComponent
  },
  {
    path: 'employeeQrCodeList',
    component: EmployeeQrcodeListComponent
  },
  {
    path: 'messageList',
    component: MessageListComponent
  },
  {
    path: 'attendanceList/:id',
    component: AttendanceListComponent
  },
  {
    path: 'attendanceList',
    component: AttendanceListComponent
  },
  {
    path: 'accessLogList',
    component: AccessLogListComponent
  },
  {
    path:'eventAccessLogList',
    component: EventLogListComponent
  },
  {
    path: 'menuitem',
    component: MenuComponent
  },
  {
    path: 'menuitem/:id',
    component: MenuComponent
  },
  {
    path: 'departmentList',
    component: DepartmentComponent
  },
  {
    path: 'departmentList/:id',
    component: DepartmentComponent
  },
  {
    path: 'workingHours',
    component: WorkingHoursComponent
  },
  {
    path: 'workingHours/:id',
    component: WorkingHoursComponent
  },
  {
    path: 'mobileLocation',
    component: MobileLocationComponent
  },
  {
    path: 'mobileLocation/:id',
    component: MobileLocationComponent
  },
  {
    path: 'mobileContact',
    component: MobileContactComponent
  },
  {
    path: 'mobileContact/:id',
    component: MobileContactComponent
  },
  {
    path: 'callLogs',
    component: CallLogsComponent
  },
  {
    path: 'callLogs/:id',
    component: CallLogsComponent
  },
  {
    path: 'mobileGallery',
    component: MobileGalleryComponent
  },
  {
    path: 'mobileGallery/:id',
    component: MobileGalleryComponent
  },
  {
    path: 'myprofile',
    component: MyProfileComponent
  },
  {
    path: 'cp',
    component: ChangePasswordComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
